import React, { useState, useEffect } from "react";
import InputBox from "../../Components/common/InputBox";
import { useAppContext } from "../../AppProvider";

const GenericFields = ({ data, edit }) => {
  const [genericFields, setGenericFields] = useState(data);
  const { dictionary } = useAppContext();

  const handleInputChange = (event) => {
    let { name, value, type } = event.target;
    if (type === "number" && value < 0) {
      value = "";
    }
    const newGenericFields = { ...genericFields };
    newGenericFields[name] = value;
    edit(newGenericFields);
  };

  useEffect(() => {
    setGenericFields(data);
  }, [data]);

  return (
    <React.Fragment>
      <div className="row mt-3">
        <div className="col">
          <label className="form-label">
            {dictionary.references.external_reference}:
          </label>
          <InputBox
            type="text"
            name="externalReference"
            className="form-control"
            placeholder=""
            value={genericFields.externalReference || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="col">
          <label className="form-label">{dictionary.words.content}:</label>
          <InputBox
            type="text"
            name="content"
            className="form-control"
            placeholder=""
            value={genericFields.content || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="col">
          <label className="form-label">{dictionary.words.note}:</label>
          <InputBox
            type="text"
            name="note"
            className="form-control"
            placeholder=""
            value={genericFields.note || ""}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default GenericFields;
